// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import { get } from 'lodash';

import transform from '@nerdwallet/transform';

const sharedSchema = {
  creditScore: {
    value: 'inputs.creditScoreRangeValue',
    whitelist: {
      '720-850': 720,
      '690-719': 690,
      '630-689': 630,
      '350-629': 350,
    },
  },
};

const purchaseSchema = {
  ...sharedSchema,
  downPayment(data) {
    return get(
      data,
      'adjustedOutputs.downPayment',
      get(data, 'inputs.downPayment') ?? get(data, 'inputs.downpayment')
    ); // HAC, MC
  },
  purchasePrice: {
    value(data) {
      return get(
        data,
        'adjustedOutputs.suggestedPurchasePrice',
        get(data, 'inputs.purchasePrice') ?? get(data, 'inputs.homePrice')
      ); // HAC, MC
    },
  },
  state: (data) =>
    get(data, 'inputs.purchaseAddress.state', get(data, 'input.state')),
  zipCode: 'outputs.zip',
};

const refinanceSchema = {
  ...sharedSchema,
  state: 'inputs.refinanceAddress.state',
  zipCode: 'outputs.zip',
};

export const transformHifcInputs = (data) => data?.resultsConfig?.inputs ?? {};

export const transformToPurchaseInputs = (data) =>
  transform(purchaseSchema, data);

export const transformToRefinanceInputs = (data) =>
  transform(refinanceSchema, data);

export default (data, app) => {
  if (app === 'hifc') {
    return transformHifcInputs(data);
  }

  if (app === 'rc') {
    return transformToRefinanceInputs(data);
  }

  return transformToPurchaseInputs(data);
};
